module.exports = __webpack_public_path__ + "img/nav.6d2b3841.svg";